import http from '@/lib/http'
import type { ConversationType } from '@/types/data'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

export default function useGetConversationById({
  conversationId,
  enabled
}: {
  conversationId: string
  enabled?: boolean
}) {
  return useQuery<ConversationType>({
    queryKey: ['getConversationById', conversationId],
    queryFn: () => http.get(`/prescriber/med-requests/conversations/${conversationId}`),
    enabled: false
  })
}
